export * from '../models/AcceptActionRequest';
export * from '../models/AddActionToProxyRequest';
export * from '../models/ApiAddReactionToDropRequest';
export * from '../models/ApiAggregatedActivity';
export * from '../models/ApiAggregatedActivityMemes';
export * from '../models/ApiAggregatedActivityPage';
export * from '../models/ApiArtistItem';
export * from '../models/ApiArtistNameItem';
export * from '../models/ApiArtistsNft';
export * from '../models/ApiArtistsPage';
export * from '../models/ApiArtistsWork';
export * from '../models/ApiAvailableRatingCredit';
export * from '../models/ApiBlockItem';
export * from '../models/ApiBlocksPage';
export * from '../models/ApiBulkRateRequest';
export * from '../models/ApiBulkRateResponse';
export * from '../models/ApiBulkRateSkippedIdentity';
export * from '../models/ApiBulkRepRequest';
export * from '../models/ApiBulkRepTarget';
export * from '../models/ApiChangeGroupVisibility';
export * from '../models/ApiChangeProfileCicRating';
export * from '../models/ApiChangeProfileRepRating';
export * from '../models/ApiCommunityMemberMinimal';
export * from '../models/ApiCompleteMultipartUploadRequest';
export * from '../models/ApiCompleteMultipartUploadRequestPart';
export * from '../models/ApiCompleteMultipartUploadResponse';
export * from '../models/ApiCreateDropPart';
export * from '../models/ApiCreateDropRequest';
export * from '../models/ApiCreateGroup';
export * from '../models/ApiCreateGroupDescription';
export * from '../models/ApiCreateMediaUploadUrlRequest';
export * from '../models/ApiCreateMediaUrlResponse';
export * from '../models/ApiCreateNewProfileProxy';
export * from '../models/ApiCreateNewProfileProxyAllocateCicAction';
export * from '../models/ApiCreateNewProfileProxyAllocateRepAction';
export * from '../models/ApiCreateNewProfileProxyCreateWaveAction';
export * from '../models/ApiCreateNewProfileProxyCreateWaveParticipationDropAction';
export * from '../models/ApiCreateNewProfileProxyRateWaveDropAction';
export * from '../models/ApiCreateNewProfileProxyReadWaveAction';
export * from '../models/ApiCreateNewWave';
export * from '../models/ApiCreateNewWaveChatConfig';
export * from '../models/ApiCreateNewWaveParticipationConfig';
export * from '../models/ApiCreateNewWaveScope';
export * from '../models/ApiCreateNewWaveVisibilityConfig';
export * from '../models/ApiCreateNewWaveVotingConfig';
export * from '../models/ApiCreateOrUpdateProfileRequest';
export * from '../models/ApiCreateWaveConfig';
export * from '../models/ApiCreateWaveDropRequest';
export * from '../models/ApiDrop';
export * from '../models/ApiDropAndDropVote';
export * from '../models/ApiDropContextProfileContext';
export * from '../models/ApiDropMedia';
export * from '../models/ApiDropMentionedUser';
export * from '../models/ApiDropMetadata';
export * from '../models/ApiDropPart';
export * from '../models/ApiDropRater';
export * from '../models/ApiDropRatingRequest';
export * from '../models/ApiDropReaction';
export * from '../models/ApiDropReferencedNFT';
export * from '../models/ApiDropSearchStrategy';
export * from '../models/ApiDropSubscriptionActions';
export * from '../models/ApiDropSubscriptionTargetAction';
export * from '../models/ApiDropTraceItem';
export * from '../models/ApiDropType';
export * from '../models/ApiDropVote';
export * from '../models/ApiDropWinningContext';
export * from '../models/ApiDropWithoutWave';
export * from '../models/ApiDropWithoutWavesPageWithoutCount';
export * from '../models/ApiDropsLeaderboardPage';
export * from '../models/ApiDropsPage';
export * from '../models/ApiFeedItem';
export * from '../models/ApiFeedItemType';
export * from '../models/ApiGroup';
export * from '../models/ApiGroupCicFilter';
export * from '../models/ApiGroupDescription';
export * from '../models/ApiGroupFilterDirection';
export * from '../models/ApiGroupFull';
export * from '../models/ApiGroupLevelFilter';
export * from '../models/ApiGroupOwnsNft';
export * from '../models/ApiGroupRepFilter';
export * from '../models/ApiGroupTdhFilter';
export * from '../models/ApiGroupTdhInclusionStrategy';
export * from '../models/ApiIdentity';
export * from '../models/ApiIdentityAndSubscriptionActions';
export * from '../models/ApiIdentitySubscriptionActions';
export * from '../models/ApiIdentitySubscriptionTargetAction';
export * from '../models/ApiIdentitySubscriptionTargetType';
export * from '../models/ApiIncomingIdentitySubscriptionsPage';
export * from '../models/ApiIntRange';
export * from '../models/ApiLightDrop';
export * from '../models/ApiLoginRequest';
export * from '../models/ApiLoginResponse';
export * from '../models/ApiNft';
export * from '../models/ApiNftMedia';
export * from '../models/ApiNftOwner';
export * from '../models/ApiNftOwnerPage';
export * from '../models/ApiNftsPage';
export * from '../models/ApiNonceResponse';
export * from '../models/ApiNotification';
export * from '../models/ApiNotificationCause';
export * from '../models/ApiNotificationsResponse';
export * from '../models/ApiOutgoingIdentitySubscriptionsPage';
export * from '../models/ApiOwnerBalance';
export * from '../models/ApiOwnerBalanceMemes';
export * from '../models/ApiOwnerBalancePage';
export * from '../models/ApiPageBase';
export * from '../models/ApiPageSortDirection';
export * from '../models/ApiPageWithNextUriBase';
export * from '../models/ApiPageWithoutCount';
export * from '../models/ApiProfileClassification';
export * from '../models/ApiProfileMin';
export * from '../models/ApiProfileProxy';
export * from '../models/ApiProfileProxyAction';
export * from '../models/ApiProfileProxyActionType';
export * from '../models/ApiQuotedDrop';
export * from '../models/ApiQuotedDropResponse';
export * from '../models/ApiRateMatter';
export * from '../models/ApiRatingWithProfileInfoAndLevel';
export * from '../models/ApiRatingWithProfileInfoAndLevelPage';
export * from '../models/ApiRedeemRefreshTokenRequest';
export * from '../models/ApiRedeemRefreshTokenResponse';
export * from '../models/ApiRegisterPushNotificationTokenRequest';
export * from '../models/ApiRepRating';
export * from '../models/ApiReplyToDrop';
export * from '../models/ApiReplyToDropResponse';
export * from '../models/ApiSeizeSettings';
export * from '../models/ApiStartMultipartMediaUploadResponse';
export * from '../models/ApiTargetAndSubscriptionActions';
export * from '../models/ApiTdhEdition';
export * from '../models/ApiTdhEditionsPage';
export * from '../models/ApiTransaction';
export * from '../models/ApiTransactionPage';
export * from '../models/ApiUpdateDropRequest';
export * from '../models/ApiUpdateProxyActionRequest';
export * from '../models/ApiUpdateWaveDecisionPause';
export * from '../models/ApiUpdateWaveRequest';
export * from '../models/ApiUploadItem';
export * from '../models/ApiUploadPartOfMultipartUploadRequest';
export * from '../models/ApiUploadPartOfMultipartUploadResponse';
export * from '../models/ApiUploadsPage';
export * from '../models/ApiWallet';
export * from '../models/ApiWave';
export * from '../models/ApiWaveChatConfig';
export * from '../models/ApiWaveConfig';
export * from '../models/ApiWaveContributorOverview';
export * from '../models/ApiWaveCreditScope';
export * from '../models/ApiWaveCreditType';
export * from '../models/ApiWaveDecision';
export * from '../models/ApiWaveDecisionAward';
export * from '../models/ApiWaveDecisionPause';
export * from '../models/ApiWaveDecisionWinner';
export * from '../models/ApiWaveDecisionsPage';
export * from '../models/ApiWaveDecisionsStrategy';
export * from '../models/ApiWaveDropsFeed';
export * from '../models/ApiWaveLog';
export * from '../models/ApiWaveMetadataType';
export * from '../models/ApiWaveMetrics';
export * from '../models/ApiWaveMin';
export * from '../models/ApiWaveOutcome';
export * from '../models/ApiWaveOutcomeCredit';
export * from '../models/ApiWaveOutcomeDistributionItem';
export * from '../models/ApiWaveOutcomeSubType';
export * from '../models/ApiWaveOutcomeType';
export * from '../models/ApiWaveParticipationConfig';
export * from '../models/ApiWaveParticipationRequirement';
export * from '../models/ApiWaveRequiredMetadata';
export * from '../models/ApiWaveScope';
export * from '../models/ApiWaveSubscriptionActions';
export * from '../models/ApiWaveSubscriptionTargetAction';
export * from '../models/ApiWaveType';
export * from '../models/ApiWaveVisibilityConfig';
export * from '../models/ApiWaveVoter';
export * from '../models/ApiWaveVotersPage';
export * from '../models/ApiWaveVotingConfig';
export * from '../models/ApiWavesOverviewType';
export * from '../models/ApiWavesPinFilter';
export * from '../models/ApiXTdhCollection';
export * from '../models/ApiXTdhCollectionsPage';
export * from '../models/ApiXTdhContribution';
export * from '../models/ApiXTdhContributionsPage';
export * from '../models/ApiXTdhCreateGrant';
export * from '../models/ApiXTdhGlobalStats';
export * from '../models/ApiXTdhGrant';
export * from '../models/ApiXTdhGrantStatus';
export * from '../models/ApiXTdhGrantTargetChain';
export * from '../models/ApiXTdhGrantToken';
export * from '../models/ApiXTdhGrantTokensPage';
export * from '../models/ApiXTdhGrantUpdateRequest';
export * from '../models/ApiXTdhGrantee';
export * from '../models/ApiXTdhGranteesPage';
export * from '../models/ApiXTdhGrantsPage';
export * from '../models/ApiXTdhStats';
export * from '../models/ApiXTdhToken';
export * from '../models/ApiXTdhTokensPage';
export * from '../models/CreateDirectMessageWaveRequest';
export * from '../models/GetWaveSubscription200Response';

import { AcceptActionRequest, AcceptActionRequestActionEnum   } from '../models/AcceptActionRequest';
import { AddActionToProxyRequest    } from '../models/AddActionToProxyRequest';
import { ApiAddReactionToDropRequest } from '../models/ApiAddReactionToDropRequest';
import { ApiAggregatedActivity } from '../models/ApiAggregatedActivity';
import { ApiAggregatedActivityMemes } from '../models/ApiAggregatedActivityMemes';
import { ApiAggregatedActivityPage } from '../models/ApiAggregatedActivityPage';
import { ApiArtistItem } from '../models/ApiArtistItem';
import { ApiArtistNameItem } from '../models/ApiArtistNameItem';
import { ApiArtistsNft } from '../models/ApiArtistsNft';
import { ApiArtistsPage } from '../models/ApiArtistsPage';
import { ApiArtistsWork } from '../models/ApiArtistsWork';
import { ApiAvailableRatingCredit } from '../models/ApiAvailableRatingCredit';
import { ApiBlockItem } from '../models/ApiBlockItem';
import { ApiBlocksPage } from '../models/ApiBlocksPage';
import { ApiBulkRateRequest     } from '../models/ApiBulkRateRequest';
import { ApiBulkRateResponse } from '../models/ApiBulkRateResponse';
import { ApiBulkRateSkippedIdentity } from '../models/ApiBulkRateSkippedIdentity';
import { ApiBulkRepRequest } from '../models/ApiBulkRepRequest';
import { ApiBulkRepTarget } from '../models/ApiBulkRepTarget';
import { ApiChangeGroupVisibility } from '../models/ApiChangeGroupVisibility';
import { ApiChangeProfileCicRating } from '../models/ApiChangeProfileCicRating';
import { ApiChangeProfileRepRating } from '../models/ApiChangeProfileRepRating';
import { ApiCommunityMemberMinimal } from '../models/ApiCommunityMemberMinimal';
import { ApiCompleteMultipartUploadRequest } from '../models/ApiCompleteMultipartUploadRequest';
import { ApiCompleteMultipartUploadRequestPart } from '../models/ApiCompleteMultipartUploadRequestPart';
import { ApiCompleteMultipartUploadResponse } from '../models/ApiCompleteMultipartUploadResponse';
import { ApiCreateDropPart } from '../models/ApiCreateDropPart';
import { ApiCreateDropRequest             } from '../models/ApiCreateDropRequest';
import { ApiCreateGroup } from '../models/ApiCreateGroup';
import { ApiCreateGroupDescription } from '../models/ApiCreateGroupDescription';
import { ApiCreateMediaUploadUrlRequest } from '../models/ApiCreateMediaUploadUrlRequest';
import { ApiCreateMediaUrlResponse } from '../models/ApiCreateMediaUrlResponse';
import { ApiCreateNewProfileProxy } from '../models/ApiCreateNewProfileProxy';
import { ApiCreateNewProfileProxyAllocateCicAction    } from '../models/ApiCreateNewProfileProxyAllocateCicAction';
import { ApiCreateNewProfileProxyAllocateRepAction    } from '../models/ApiCreateNewProfileProxyAllocateRepAction';
import { ApiCreateNewProfileProxyCreateWaveAction   } from '../models/ApiCreateNewProfileProxyCreateWaveAction';
import { ApiCreateNewProfileProxyCreateWaveParticipationDropAction   } from '../models/ApiCreateNewProfileProxyCreateWaveParticipationDropAction';
import { ApiCreateNewProfileProxyRateWaveDropAction   } from '../models/ApiCreateNewProfileProxyRateWaveDropAction';
import { ApiCreateNewProfileProxyReadWaveAction   } from '../models/ApiCreateNewProfileProxyReadWaveAction';
import { ApiCreateNewWave } from '../models/ApiCreateNewWave';
import { ApiCreateNewWaveChatConfig } from '../models/ApiCreateNewWaveChatConfig';
import { ApiCreateNewWaveParticipationConfig } from '../models/ApiCreateNewWaveParticipationConfig';
import { ApiCreateNewWaveScope } from '../models/ApiCreateNewWaveScope';
import { ApiCreateNewWaveVisibilityConfig } from '../models/ApiCreateNewWaveVisibilityConfig';
import { ApiCreateNewWaveVotingConfig         } from '../models/ApiCreateNewWaveVotingConfig';
import { ApiCreateOrUpdateProfileRequest        } from '../models/ApiCreateOrUpdateProfileRequest';
import { ApiCreateWaveConfig        } from '../models/ApiCreateWaveConfig';
import { ApiCreateWaveDropRequest } from '../models/ApiCreateWaveDropRequest';
import { ApiDrop                          } from '../models/ApiDrop';
import { ApiDropAndDropVote } from '../models/ApiDropAndDropVote';
import { ApiDropContextProfileContext } from '../models/ApiDropContextProfileContext';
import { ApiDropMedia } from '../models/ApiDropMedia';
import { ApiDropMentionedUser } from '../models/ApiDropMentionedUser';
import { ApiDropMetadata } from '../models/ApiDropMetadata';
import { ApiDropPart } from '../models/ApiDropPart';
import { ApiDropRater } from '../models/ApiDropRater';
import { ApiDropRatingRequest } from '../models/ApiDropRatingRequest';
import { ApiDropReaction } from '../models/ApiDropReaction';
import { ApiDropReferencedNFT } from '../models/ApiDropReferencedNFT';
import { ApiDropSearchStrategy } from '../models/ApiDropSearchStrategy';
import { ApiDropSubscriptionActions } from '../models/ApiDropSubscriptionActions';
import { ApiDropSubscriptionTargetAction } from '../models/ApiDropSubscriptionTargetAction';
import { ApiDropTraceItem } from '../models/ApiDropTraceItem';
import { ApiDropType } from '../models/ApiDropType';
import { ApiDropVote } from '../models/ApiDropVote';
import { ApiDropWinningContext } from '../models/ApiDropWinningContext';
import { ApiDropWithoutWave                         } from '../models/ApiDropWithoutWave';
import { ApiDropWithoutWavesPageWithoutCount } from '../models/ApiDropWithoutWavesPageWithoutCount';
import { ApiDropsLeaderboardPage } from '../models/ApiDropsLeaderboardPage';
import { ApiDropsPage } from '../models/ApiDropsPage';
import { ApiFeedItem    } from '../models/ApiFeedItem';
import { ApiFeedItemType } from '../models/ApiFeedItemType';
import { ApiGroup } from '../models/ApiGroup';
import { ApiGroupCicFilter     } from '../models/ApiGroupCicFilter';
import { ApiGroupDescription } from '../models/ApiGroupDescription';
import { ApiGroupFilterDirection } from '../models/ApiGroupFilterDirection';
import { ApiGroupFull } from '../models/ApiGroupFull';
import { ApiGroupLevelFilter } from '../models/ApiGroupLevelFilter';
import { ApiGroupOwnsNft, ApiGroupOwnsNftNameEnum    } from '../models/ApiGroupOwnsNft';
import { ApiGroupRepFilter      } from '../models/ApiGroupRepFilter';
import { ApiGroupTdhFilter    } from '../models/ApiGroupTdhFilter';
import { ApiGroupTdhInclusionStrategy } from '../models/ApiGroupTdhInclusionStrategy';
import { ApiIdentity                       } from '../models/ApiIdentity';
import { ApiIdentityAndSubscriptionActions } from '../models/ApiIdentityAndSubscriptionActions';
import { ApiIdentitySubscriptionActions } from '../models/ApiIdentitySubscriptionActions';
import { ApiIdentitySubscriptionTargetAction } from '../models/ApiIdentitySubscriptionTargetAction';
import { ApiIdentitySubscriptionTargetType } from '../models/ApiIdentitySubscriptionTargetType';
import { ApiIncomingIdentitySubscriptionsPage } from '../models/ApiIncomingIdentitySubscriptionsPage';
import { ApiIntRange } from '../models/ApiIntRange';
import { ApiLightDrop         } from '../models/ApiLightDrop';
import { ApiLoginRequest } from '../models/ApiLoginRequest';
import { ApiLoginResponse } from '../models/ApiLoginResponse';
import { ApiNft      , ApiNftTokenTypeEnum                               } from '../models/ApiNft';
import { ApiNftMedia } from '../models/ApiNftMedia';
import { ApiNftOwner } from '../models/ApiNftOwner';
import { ApiNftOwnerPage } from '../models/ApiNftOwnerPage';
import { ApiNftsPage } from '../models/ApiNftsPage';
import { ApiNonceResponse } from '../models/ApiNonceResponse';
import { ApiNotification        } from '../models/ApiNotification';
import { ApiNotificationCause } from '../models/ApiNotificationCause';
import { ApiNotificationsResponse } from '../models/ApiNotificationsResponse';
import { ApiOutgoingIdentitySubscriptionsPage } from '../models/ApiOutgoingIdentitySubscriptionsPage';
import { ApiOwnerBalance } from '../models/ApiOwnerBalance';
import { ApiOwnerBalanceMemes } from '../models/ApiOwnerBalanceMemes';
import { ApiOwnerBalancePage } from '../models/ApiOwnerBalancePage';
import { ApiPageBase } from '../models/ApiPageBase';
import { ApiPageSortDirection } from '../models/ApiPageSortDirection';
import { ApiPageWithNextUriBase } from '../models/ApiPageWithNextUriBase';
import { ApiPageWithoutCount } from '../models/ApiPageWithoutCount';
import { ApiProfileClassification } from '../models/ApiProfileClassification';
import { ApiProfileMin } from '../models/ApiProfileMin';
import { ApiProfileProxy } from '../models/ApiProfileProxy';
import { ApiProfileProxyAction             } from '../models/ApiProfileProxyAction';
import { ApiProfileProxyActionType } from '../models/ApiProfileProxyActionType';
import { ApiQuotedDrop } from '../models/ApiQuotedDrop';
import { ApiQuotedDropResponse } from '../models/ApiQuotedDropResponse';
import { ApiRateMatter } from '../models/ApiRateMatter';
import { ApiRatingWithProfileInfoAndLevel } from '../models/ApiRatingWithProfileInfoAndLevel';
import { ApiRatingWithProfileInfoAndLevelPage } from '../models/ApiRatingWithProfileInfoAndLevelPage';
import { ApiRedeemRefreshTokenRequest } from '../models/ApiRedeemRefreshTokenRequest';
import { ApiRedeemRefreshTokenResponse } from '../models/ApiRedeemRefreshTokenResponse';
import { ApiRegisterPushNotificationTokenRequest } from '../models/ApiRegisterPushNotificationTokenRequest';
import { ApiRepRating } from '../models/ApiRepRating';
import { ApiReplyToDrop } from '../models/ApiReplyToDrop';
import { ApiReplyToDropResponse } from '../models/ApiReplyToDropResponse';
import { ApiSeizeSettings } from '../models/ApiSeizeSettings';
import { ApiStartMultipartMediaUploadResponse } from '../models/ApiStartMultipartMediaUploadResponse';
import { ApiTargetAndSubscriptionActions } from '../models/ApiTargetAndSubscriptionActions';
import { ApiTdhEdition } from '../models/ApiTdhEdition';
import { ApiTdhEditionsPage } from '../models/ApiTdhEditionsPage';
import { ApiTransaction } from '../models/ApiTransaction';
import { ApiTransactionPage } from '../models/ApiTransactionPage';
import { ApiUpdateDropRequest } from '../models/ApiUpdateDropRequest';
import { ApiUpdateProxyActionRequest } from '../models/ApiUpdateProxyActionRequest';
import { ApiUpdateWaveDecisionPause } from '../models/ApiUpdateWaveDecisionPause';
import { ApiUpdateWaveRequest } from '../models/ApiUpdateWaveRequest';
import { ApiUploadItem } from '../models/ApiUploadItem';
import { ApiUploadPartOfMultipartUploadRequest } from '../models/ApiUploadPartOfMultipartUploadRequest';
import { ApiUploadPartOfMultipartUploadResponse } from '../models/ApiUploadPartOfMultipartUploadResponse';
import { ApiUploadsPage } from '../models/ApiUploadsPage';
import { ApiWallet } from '../models/ApiWallet';
import { ApiWave } from '../models/ApiWave';
import { ApiWaveChatConfig } from '../models/ApiWaveChatConfig';
import { ApiWaveConfig          } from '../models/ApiWaveConfig';
import { ApiWaveContributorOverview } from '../models/ApiWaveContributorOverview';
import { ApiWaveCreditScope } from '../models/ApiWaveCreditScope';
import { ApiWaveCreditType } from '../models/ApiWaveCreditType';
import { ApiWaveDecision } from '../models/ApiWaveDecision';
import { ApiWaveDecisionAward       } from '../models/ApiWaveDecisionAward';
import { ApiWaveDecisionPause } from '../models/ApiWaveDecisionPause';
import { ApiWaveDecisionWinner } from '../models/ApiWaveDecisionWinner';
import { ApiWaveDecisionsPage } from '../models/ApiWaveDecisionsPage';
import { ApiWaveDecisionsStrategy } from '../models/ApiWaveDecisionsStrategy';
import { ApiWaveDropsFeed } from '../models/ApiWaveDropsFeed';
import { ApiWaveLog } from '../models/ApiWaveLog';
import { ApiWaveMetadataType } from '../models/ApiWaveMetadataType';
import { ApiWaveMetrics } from '../models/ApiWaveMetrics';
import { ApiWaveMin                    } from '../models/ApiWaveMin';
import { ApiWaveOutcome        } from '../models/ApiWaveOutcome';
import { ApiWaveOutcomeCredit } from '../models/ApiWaveOutcomeCredit';
import { ApiWaveOutcomeDistributionItem } from '../models/ApiWaveOutcomeDistributionItem';
import { ApiWaveOutcomeSubType } from '../models/ApiWaveOutcomeSubType';
import { ApiWaveOutcomeType } from '../models/ApiWaveOutcomeType';
import { ApiWaveParticipationConfig } from '../models/ApiWaveParticipationConfig';
import { ApiWaveParticipationRequirement } from '../models/ApiWaveParticipationRequirement';
import { ApiWaveRequiredMetadata   } from '../models/ApiWaveRequiredMetadata';
import { ApiWaveScope } from '../models/ApiWaveScope';
import { ApiWaveSubscriptionActions } from '../models/ApiWaveSubscriptionActions';
import { ApiWaveSubscriptionTargetAction } from '../models/ApiWaveSubscriptionTargetAction';
import { ApiWaveType } from '../models/ApiWaveType';
import { ApiWaveVisibilityConfig } from '../models/ApiWaveVisibilityConfig';
import { ApiWaveVoter } from '../models/ApiWaveVoter';
import { ApiWaveVotersPage } from '../models/ApiWaveVotersPage';
import { ApiWaveVotingConfig         } from '../models/ApiWaveVotingConfig';
import { ApiWavesOverviewType } from '../models/ApiWavesOverviewType';
import { ApiWavesPinFilter } from '../models/ApiWavesPinFilter';
import { ApiXTdhCollection } from '../models/ApiXTdhCollection';
import { ApiXTdhCollectionsPage } from '../models/ApiXTdhCollectionsPage';
import { ApiXTdhContribution } from '../models/ApiXTdhContribution';
import { ApiXTdhContributionsPage } from '../models/ApiXTdhContributionsPage';
import { ApiXTdhCreateGrant       } from '../models/ApiXTdhCreateGrant';
import { ApiXTdhGlobalStats } from '../models/ApiXTdhGlobalStats';
import { ApiXTdhGrant                } from '../models/ApiXTdhGrant';
import { ApiXTdhGrantStatus } from '../models/ApiXTdhGrantStatus';
import { ApiXTdhGrantTargetChain } from '../models/ApiXTdhGrantTargetChain';
import { ApiXTdhGrantToken } from '../models/ApiXTdhGrantToken';
import { ApiXTdhGrantTokensPage } from '../models/ApiXTdhGrantTokensPage';
import { ApiXTdhGrantUpdateRequest } from '../models/ApiXTdhGrantUpdateRequest';
import { ApiXTdhGrantee } from '../models/ApiXTdhGrantee';
import { ApiXTdhGranteesPage } from '../models/ApiXTdhGranteesPage';
import { ApiXTdhGrantsPage } from '../models/ApiXTdhGrantsPage';
import { ApiXTdhStats } from '../models/ApiXTdhStats';
import { ApiXTdhToken } from '../models/ApiXTdhToken';
import { ApiXTdhTokensPage } from '../models/ApiXTdhTokensPage';
import { CreateDirectMessageWaveRequest } from '../models/CreateDirectMessageWaveRequest';
import { GetWaveSubscription200Response } from '../models/GetWaveSubscription200Response';

/* tslint:disable:no-unused-variable */
let primitives = [
                    "string",
                    "boolean",
                    "double",
                    "integer",
                    "long",
                    "float",
                    "number",
                    "any"
                 ];

let enumsMap: Set<string> = new Set<string>([
    "AcceptActionRequestActionEnum",
    "ApiDropSearchStrategy",
    "ApiDropSubscriptionTargetAction",
    "ApiDropType",
    "ApiFeedItemType",
    "ApiGroupFilterDirection",
    "ApiGroupOwnsNftNameEnum",
    "ApiGroupTdhInclusionStrategy",
    "ApiIdentitySubscriptionTargetAction",
    "ApiIdentitySubscriptionTargetType",
    "ApiNftTokenTypeEnum",
    "ApiNotificationCause",
    "ApiPageSortDirection",
    "ApiProfileClassification",
    "ApiProfileProxyActionType",
    "ApiRateMatter",
    "ApiWaveCreditScope",
    "ApiWaveCreditType",
    "ApiWaveMetadataType",
    "ApiWaveOutcomeCredit",
    "ApiWaveOutcomeSubType",
    "ApiWaveOutcomeType",
    "ApiWaveParticipationRequirement",
    "ApiWaveSubscriptionTargetAction",
    "ApiWaveType",
    "ApiWavesOverviewType",
    "ApiWavesPinFilter",
    "ApiXTdhGrantStatus",
    "ApiXTdhGrantTargetChain",
]);

let typeMap: {[index: string]: any} = {
    "AcceptActionRequest": AcceptActionRequest,
    "AddActionToProxyRequest": AddActionToProxyRequest,
    "ApiAddReactionToDropRequest": ApiAddReactionToDropRequest,
    "ApiAggregatedActivity": ApiAggregatedActivity,
    "ApiAggregatedActivityMemes": ApiAggregatedActivityMemes,
    "ApiAggregatedActivityPage": ApiAggregatedActivityPage,
    "ApiArtistItem": ApiArtistItem,
    "ApiArtistNameItem": ApiArtistNameItem,
    "ApiArtistsNft": ApiArtistsNft,
    "ApiArtistsPage": ApiArtistsPage,
    "ApiArtistsWork": ApiArtistsWork,
    "ApiAvailableRatingCredit": ApiAvailableRatingCredit,
    "ApiBlockItem": ApiBlockItem,
    "ApiBlocksPage": ApiBlocksPage,
    "ApiBulkRateRequest": ApiBulkRateRequest,
    "ApiBulkRateResponse": ApiBulkRateResponse,
    "ApiBulkRateSkippedIdentity": ApiBulkRateSkippedIdentity,
    "ApiBulkRepRequest": ApiBulkRepRequest,
    "ApiBulkRepTarget": ApiBulkRepTarget,
    "ApiChangeGroupVisibility": ApiChangeGroupVisibility,
    "ApiChangeProfileCicRating": ApiChangeProfileCicRating,
    "ApiChangeProfileRepRating": ApiChangeProfileRepRating,
    "ApiCommunityMemberMinimal": ApiCommunityMemberMinimal,
    "ApiCompleteMultipartUploadRequest": ApiCompleteMultipartUploadRequest,
    "ApiCompleteMultipartUploadRequestPart": ApiCompleteMultipartUploadRequestPart,
    "ApiCompleteMultipartUploadResponse": ApiCompleteMultipartUploadResponse,
    "ApiCreateDropPart": ApiCreateDropPart,
    "ApiCreateDropRequest": ApiCreateDropRequest,
    "ApiCreateGroup": ApiCreateGroup,
    "ApiCreateGroupDescription": ApiCreateGroupDescription,
    "ApiCreateMediaUploadUrlRequest": ApiCreateMediaUploadUrlRequest,
    "ApiCreateMediaUrlResponse": ApiCreateMediaUrlResponse,
    "ApiCreateNewProfileProxy": ApiCreateNewProfileProxy,
    "ApiCreateNewProfileProxyAllocateCicAction": ApiCreateNewProfileProxyAllocateCicAction,
    "ApiCreateNewProfileProxyAllocateRepAction": ApiCreateNewProfileProxyAllocateRepAction,
    "ApiCreateNewProfileProxyCreateWaveAction": ApiCreateNewProfileProxyCreateWaveAction,
    "ApiCreateNewProfileProxyCreateWaveParticipationDropAction": ApiCreateNewProfileProxyCreateWaveParticipationDropAction,
    "ApiCreateNewProfileProxyRateWaveDropAction": ApiCreateNewProfileProxyRateWaveDropAction,
    "ApiCreateNewProfileProxyReadWaveAction": ApiCreateNewProfileProxyReadWaveAction,
    "ApiCreateNewWave": ApiCreateNewWave,
    "ApiCreateNewWaveChatConfig": ApiCreateNewWaveChatConfig,
    "ApiCreateNewWaveParticipationConfig": ApiCreateNewWaveParticipationConfig,
    "ApiCreateNewWaveScope": ApiCreateNewWaveScope,
    "ApiCreateNewWaveVisibilityConfig": ApiCreateNewWaveVisibilityConfig,
    "ApiCreateNewWaveVotingConfig": ApiCreateNewWaveVotingConfig,
    "ApiCreateOrUpdateProfileRequest": ApiCreateOrUpdateProfileRequest,
    "ApiCreateWaveConfig": ApiCreateWaveConfig,
    "ApiCreateWaveDropRequest": ApiCreateWaveDropRequest,
    "ApiDrop": ApiDrop,
    "ApiDropAndDropVote": ApiDropAndDropVote,
    "ApiDropContextProfileContext": ApiDropContextProfileContext,
    "ApiDropMedia": ApiDropMedia,
    "ApiDropMentionedUser": ApiDropMentionedUser,
    "ApiDropMetadata": ApiDropMetadata,
    "ApiDropPart": ApiDropPart,
    "ApiDropRater": ApiDropRater,
    "ApiDropRatingRequest": ApiDropRatingRequest,
    "ApiDropReaction": ApiDropReaction,
    "ApiDropReferencedNFT": ApiDropReferencedNFT,
    "ApiDropSubscriptionActions": ApiDropSubscriptionActions,
    "ApiDropTraceItem": ApiDropTraceItem,
    "ApiDropVote": ApiDropVote,
    "ApiDropWinningContext": ApiDropWinningContext,
    "ApiDropWithoutWave": ApiDropWithoutWave,
    "ApiDropWithoutWavesPageWithoutCount": ApiDropWithoutWavesPageWithoutCount,
    "ApiDropsLeaderboardPage": ApiDropsLeaderboardPage,
    "ApiDropsPage": ApiDropsPage,
    "ApiFeedItem": ApiFeedItem,
    "ApiGroup": ApiGroup,
    "ApiGroupCicFilter": ApiGroupCicFilter,
    "ApiGroupDescription": ApiGroupDescription,
    "ApiGroupFull": ApiGroupFull,
    "ApiGroupLevelFilter": ApiGroupLevelFilter,
    "ApiGroupOwnsNft": ApiGroupOwnsNft,
    "ApiGroupRepFilter": ApiGroupRepFilter,
    "ApiGroupTdhFilter": ApiGroupTdhFilter,
    "ApiIdentity": ApiIdentity,
    "ApiIdentityAndSubscriptionActions": ApiIdentityAndSubscriptionActions,
    "ApiIdentitySubscriptionActions": ApiIdentitySubscriptionActions,
    "ApiIncomingIdentitySubscriptionsPage": ApiIncomingIdentitySubscriptionsPage,
    "ApiIntRange": ApiIntRange,
    "ApiLightDrop": ApiLightDrop,
    "ApiLoginRequest": ApiLoginRequest,
    "ApiLoginResponse": ApiLoginResponse,
    "ApiNft": ApiNft,
    "ApiNftMedia": ApiNftMedia,
    "ApiNftOwner": ApiNftOwner,
    "ApiNftOwnerPage": ApiNftOwnerPage,
    "ApiNftsPage": ApiNftsPage,
    "ApiNonceResponse": ApiNonceResponse,
    "ApiNotification": ApiNotification,
    "ApiNotificationsResponse": ApiNotificationsResponse,
    "ApiOutgoingIdentitySubscriptionsPage": ApiOutgoingIdentitySubscriptionsPage,
    "ApiOwnerBalance": ApiOwnerBalance,
    "ApiOwnerBalanceMemes": ApiOwnerBalanceMemes,
    "ApiOwnerBalancePage": ApiOwnerBalancePage,
    "ApiPageBase": ApiPageBase,
    "ApiPageWithNextUriBase": ApiPageWithNextUriBase,
    "ApiPageWithoutCount": ApiPageWithoutCount,
    "ApiProfileMin": ApiProfileMin,
    "ApiProfileProxy": ApiProfileProxy,
    "ApiProfileProxyAction": ApiProfileProxyAction,
    "ApiQuotedDrop": ApiQuotedDrop,
    "ApiQuotedDropResponse": ApiQuotedDropResponse,
    "ApiRatingWithProfileInfoAndLevel": ApiRatingWithProfileInfoAndLevel,
    "ApiRatingWithProfileInfoAndLevelPage": ApiRatingWithProfileInfoAndLevelPage,
    "ApiRedeemRefreshTokenRequest": ApiRedeemRefreshTokenRequest,
    "ApiRedeemRefreshTokenResponse": ApiRedeemRefreshTokenResponse,
    "ApiRegisterPushNotificationTokenRequest": ApiRegisterPushNotificationTokenRequest,
    "ApiRepRating": ApiRepRating,
    "ApiReplyToDrop": ApiReplyToDrop,
    "ApiReplyToDropResponse": ApiReplyToDropResponse,
    "ApiSeizeSettings": ApiSeizeSettings,
    "ApiStartMultipartMediaUploadResponse": ApiStartMultipartMediaUploadResponse,
    "ApiTargetAndSubscriptionActions": ApiTargetAndSubscriptionActions,
    "ApiTdhEdition": ApiTdhEdition,
    "ApiTdhEditionsPage": ApiTdhEditionsPage,
    "ApiTransaction": ApiTransaction,
    "ApiTransactionPage": ApiTransactionPage,
    "ApiUpdateDropRequest": ApiUpdateDropRequest,
    "ApiUpdateProxyActionRequest": ApiUpdateProxyActionRequest,
    "ApiUpdateWaveDecisionPause": ApiUpdateWaveDecisionPause,
    "ApiUpdateWaveRequest": ApiUpdateWaveRequest,
    "ApiUploadItem": ApiUploadItem,
    "ApiUploadPartOfMultipartUploadRequest": ApiUploadPartOfMultipartUploadRequest,
    "ApiUploadPartOfMultipartUploadResponse": ApiUploadPartOfMultipartUploadResponse,
    "ApiUploadsPage": ApiUploadsPage,
    "ApiWallet": ApiWallet,
    "ApiWave": ApiWave,
    "ApiWaveChatConfig": ApiWaveChatConfig,
    "ApiWaveConfig": ApiWaveConfig,
    "ApiWaveContributorOverview": ApiWaveContributorOverview,
    "ApiWaveDecision": ApiWaveDecision,
    "ApiWaveDecisionAward": ApiWaveDecisionAward,
    "ApiWaveDecisionPause": ApiWaveDecisionPause,
    "ApiWaveDecisionWinner": ApiWaveDecisionWinner,
    "ApiWaveDecisionsPage": ApiWaveDecisionsPage,
    "ApiWaveDecisionsStrategy": ApiWaveDecisionsStrategy,
    "ApiWaveDropsFeed": ApiWaveDropsFeed,
    "ApiWaveLog": ApiWaveLog,
    "ApiWaveMetrics": ApiWaveMetrics,
    "ApiWaveMin": ApiWaveMin,
    "ApiWaveOutcome": ApiWaveOutcome,
    "ApiWaveOutcomeDistributionItem": ApiWaveOutcomeDistributionItem,
    "ApiWaveParticipationConfig": ApiWaveParticipationConfig,
    "ApiWaveRequiredMetadata": ApiWaveRequiredMetadata,
    "ApiWaveScope": ApiWaveScope,
    "ApiWaveSubscriptionActions": ApiWaveSubscriptionActions,
    "ApiWaveVisibilityConfig": ApiWaveVisibilityConfig,
    "ApiWaveVoter": ApiWaveVoter,
    "ApiWaveVotersPage": ApiWaveVotersPage,
    "ApiWaveVotingConfig": ApiWaveVotingConfig,
    "ApiXTdhCollection": ApiXTdhCollection,
    "ApiXTdhCollectionsPage": ApiXTdhCollectionsPage,
    "ApiXTdhContribution": ApiXTdhContribution,
    "ApiXTdhContributionsPage": ApiXTdhContributionsPage,
    "ApiXTdhCreateGrant": ApiXTdhCreateGrant,
    "ApiXTdhGlobalStats": ApiXTdhGlobalStats,
    "ApiXTdhGrant": ApiXTdhGrant,
    "ApiXTdhGrantToken": ApiXTdhGrantToken,
    "ApiXTdhGrantTokensPage": ApiXTdhGrantTokensPage,
    "ApiXTdhGrantUpdateRequest": ApiXTdhGrantUpdateRequest,
    "ApiXTdhGrantee": ApiXTdhGrantee,
    "ApiXTdhGranteesPage": ApiXTdhGranteesPage,
    "ApiXTdhGrantsPage": ApiXTdhGrantsPage,
    "ApiXTdhStats": ApiXTdhStats,
    "ApiXTdhToken": ApiXTdhToken,
    "ApiXTdhTokensPage": ApiXTdhTokensPage,
    "CreateDirectMessageWaveRequest": CreateDirectMessageWaveRequest,
    "GetWaveSubscription200Response": GetWaveSubscription200Response,
}

type MimeTypeDescriptor = {
    type: string;
    subtype: string;
    subtypeTokens: string[];
};

/**
 * Every mime-type consists of a type, subtype, and optional parameters.
 * The subtype can be composite, including information about the content format.
 * For example: `application/json-patch+json`, `application/merge-patch+json`.
 *
 * This helper transforms a string mime-type into an internal representation.
 * This simplifies the implementation of predicates that in turn define common rules for parsing or stringifying
 * the payload.
 */
const parseMimeType = (mimeType: string): MimeTypeDescriptor => {
    const [type = '', subtype = ''] = mimeType.split('/');
    return {
        type,
        subtype,
        subtypeTokens: subtype.split('+'),
    };
};

type MimeTypePredicate = (mimeType: string) => boolean;

// This factory creates a predicate function that checks a string mime-type against defined rules.
const mimeTypePredicateFactory = (predicate: (descriptor: MimeTypeDescriptor) => boolean): MimeTypePredicate => (mimeType) => predicate(parseMimeType(mimeType));

// Use this factory when you need to define a simple predicate based only on type and, if applicable, subtype.
const mimeTypeSimplePredicateFactory = (type: string, subtype?: string): MimeTypePredicate => mimeTypePredicateFactory((descriptor) => {
    if (descriptor.type !== type) return false;
    if (subtype != null && descriptor.subtype !== subtype) return false;
    return true;
});

// Creating a set of named predicates that will help us determine how to handle different mime-types
const isTextLikeMimeType = mimeTypeSimplePredicateFactory('text');
const isJsonMimeType = mimeTypeSimplePredicateFactory('application', 'json');
const isJsonLikeMimeType = mimeTypePredicateFactory((descriptor) => descriptor.type === 'application' && descriptor.subtypeTokens.some((item) => item === 'json'));
const isOctetStreamMimeType = mimeTypeSimplePredicateFactory('application', 'octet-stream');
const isFormUrlencodedMimeType = mimeTypeSimplePredicateFactory('application', 'x-www-form-urlencoded');

// Defining a list of mime-types in the order of prioritization for handling.
const supportedMimeTypePredicatesWithPriority: MimeTypePredicate[] = [
    isJsonMimeType,
    isJsonLikeMimeType,
    isTextLikeMimeType,
    isOctetStreamMimeType,
    isFormUrlencodedMimeType,
];

const nullableSuffix = " | null";
const optionalSuffix = " | undefined";
const arrayPrefix = "Array<";
const arraySuffix = ">";
const mapPrefix = "{ [key: string]: ";
const mapSuffix = "; }";

export class ObjectSerializer {
    public static findCorrectType(data: any, expectedType: string) {
        if (data == undefined) {
            return expectedType;
        } else if (primitives.indexOf(expectedType.toLowerCase()) !== -1) {
            return expectedType;
        } else if (expectedType === "Date") {
            return expectedType;
        } else {
            if (enumsMap.has(expectedType)) {
                return expectedType;
            }

            if (!typeMap[expectedType]) {
                return expectedType; // w/e we don't know the type
            }

            // Check the discriminator
            let discriminatorProperty = typeMap[expectedType].discriminator;
            if (discriminatorProperty == null) {
                return expectedType; // the type does not have a discriminator. use it.
            } else {
                if (data[discriminatorProperty]) {
                    var discriminatorType = data[discriminatorProperty];
                    let mapping = typeMap[expectedType].mapping;
                    if (mapping != undefined && mapping[discriminatorType]) {
                        return mapping[discriminatorType]; // use the type given in the discriminator
                    } else if(typeMap[discriminatorType]) {
                        return discriminatorType;
                    } else {
                        return expectedType; // discriminator did not map to a type
                    }
                } else {
                    return expectedType; // discriminator was not present (or an empty string)
                }
            }
        }
    }

    public static serialize(data: any, type: string, format: string): any {
        if (data == undefined) {
            return data;
        } else if (primitives.indexOf(type.toLowerCase()) !== -1) {
            return data;
        } else if (type.endsWith(nullableSuffix)) {
            let subType: string = type.slice(0, -nullableSuffix.length); // Type | null => Type
            return ObjectSerializer.serialize(data, subType, format);
        } else if (type.endsWith(optionalSuffix)) {
            let subType: string = type.slice(0, -optionalSuffix.length); // Type | undefined => Type
            return ObjectSerializer.serialize(data, subType, format);
        } else if (type.startsWith(arrayPrefix)) {
            let subType: string = type.slice(arrayPrefix.length, -arraySuffix.length); // Array<Type> => Type
            let transformedData: any[] = [];
            for (let date of data) {
                transformedData.push(ObjectSerializer.serialize(date, subType, format));
            }
            return transformedData;
        } else if (type.startsWith(mapPrefix)) {
            let subType: string = type.slice(mapPrefix.length, -mapSuffix.length); // { [key: string]: Type; } => Type
            let transformedData: { [key: string]: any } = {};
            for (let key in data) {
                transformedData[key] = ObjectSerializer.serialize(
                    data[key],
                    subType,
                    format,
                );
            }
            return transformedData;
        } else if (type === "Date") {
            if (format == "date") {
                let month = data.getMonth()+1
                month = month < 10 ? "0" + month.toString() : month.toString()
                let day = data.getDate();
                day = day < 10 ? "0" + day.toString() : day.toString();

                return data.getFullYear() + "-" + month + "-" + day;
            } else {
                return data.toISOString();
            }
        } else {
            if (enumsMap.has(type)) {
                return data;
            }
            if (!typeMap[type]) { // in case we dont know the type
                return data;
            }

            // Get the actual type of this object
            type = this.findCorrectType(data, type);

            // get the map for the correct type.
            let attributeTypes = typeMap[type].getAttributeTypeMap();
            let instance: {[index: string]: any} = {};
            for (let attributeType of attributeTypes) {
                instance[attributeType.baseName] = ObjectSerializer.serialize(data[attributeType.name], attributeType.type, attributeType.format);
            }
            return instance;
        }
    }

    public static deserialize(data: any, type: string, format: string): any {
        // polymorphism may change the actual type.
        type = ObjectSerializer.findCorrectType(data, type);
        if (data == undefined) {
            return data;
        } else if (primitives.indexOf(type.toLowerCase()) !== -1) {
            return data;
        } else if (type.endsWith(nullableSuffix)) {
            let subType: string = type.slice(0, -nullableSuffix.length); // Type | null => Type
            return ObjectSerializer.deserialize(data, subType, format);
        } else if (type.endsWith(optionalSuffix)) {
            let subType: string = type.slice(0, -optionalSuffix.length); // Type | undefined => Type
            return ObjectSerializer.deserialize(data, subType, format);
        } else if (type.startsWith(arrayPrefix)) {
            let subType: string = type.slice(arrayPrefix.length, -arraySuffix.length); // Array<Type> => Type
            let transformedData: any[] = [];
            for (let date of data) {
                transformedData.push(ObjectSerializer.deserialize(date, subType, format));
            }
            return transformedData;
        } else if (type.startsWith(mapPrefix)) {
            let subType: string = type.slice(mapPrefix.length, -mapSuffix.length); // { [key: string]: Type; } => Type
            let transformedData: { [key: string]: any } = {};
            for (let key in data) {
                transformedData[key] = ObjectSerializer.deserialize(
                    data[key],
                    subType,
                    format,
                );
            }
            return transformedData;
        } else if (type === "Date") {
            return new Date(data);
        } else {
            if (enumsMap.has(type)) {// is Enum
                return data;
            }

            if (!typeMap[type]) { // dont know the type
                return data;
            }
            let instance = new typeMap[type]();
            let attributeTypes = typeMap[type].getAttributeTypeMap();
            for (let attributeType of attributeTypes) {
                let value = ObjectSerializer.deserialize(data[attributeType.baseName], attributeType.type, attributeType.format);
                if (value !== undefined) {
                    instance[attributeType.name] = value;
                }
            }
            return instance;
        }
    }


    /**
     * Normalize media type
     *
     * We currently do not handle any media types attributes, i.e. anything
     * after a semicolon. All content is assumed to be UTF-8 compatible.
     */
    public static normalizeMediaType(mediaType: string | undefined): string | undefined {
        if (mediaType === undefined) {
            return undefined;
        }
        return (mediaType.split(";")[0] ?? '').trim().toLowerCase();
    }

    /**
     * From a list of possible media types, choose the one we can handle best.
     *
     * The order of the given media types does not have any impact on the choice
     * made.
     */
    public static getPreferredMediaType(mediaTypes: Array<string>): string {
        /** According to OAS 3 we should default to json */
        if (mediaTypes.length === 0) {
            return "application/json";
        }

        const normalMediaTypes = mediaTypes.map(this.normalizeMediaType);

        for (const predicate of supportedMimeTypePredicatesWithPriority) {
            for (const mediaType of normalMediaTypes) {
                if (mediaType != null && predicate(mediaType)) {
                    return mediaType;
                }
            }
        }

        throw new Error("None of the given media types are supported: " + mediaTypes.join(", "));
    }

    /**
     * Convert data to a string according the given media type
     */
    public static stringify(data: any, mediaType: string): string {
        if (isTextLikeMimeType(mediaType)) {
            return String(data);
        }

        if (isJsonLikeMimeType(mediaType)) {
            return JSON.stringify(data);
        }

        throw new Error("The mediaType " + mediaType + " is not supported by ObjectSerializer.stringify.");
    }

    /**
     * Parse data from a string according to the given media type
     */
    public static parse(rawData: string, mediaType: string | undefined) {
        if (mediaType === undefined) {
            throw new Error("Cannot parse content. No Content-Type defined.");
        }

        if (isTextLikeMimeType(mediaType)) {
            return rawData;
        }

        if (isJsonLikeMimeType(mediaType)) {
            return JSON.parse(rawData);
        }

        throw new Error("The mediaType " + mediaType + " is not supported by ObjectSerializer.parse.");
    }
}
